import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Aditivo from '../../../../components/auth/contratos/listar/form_arquivo'


function AditivoContratoScreen() {

    return (
        <Fragment>
            <Head titulo="Anexando Termo Aditivo" />
            <HeaderLogged />
            <Container>
               <Aditivo />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default AditivoContratoScreen;